CustomTC.define('modules/load-data',['modules/core', 'modules/options', 'modules/constants', 'modules/util', 'modules/config'], function(core, options, constants, util, config) {
    return {
        getPerformanceStats: function(id, callback) {
            if (options.getApiUrl() === '' || !options.getApiUrl()) {
                core.getJSON(config.domain + "/api/get-performance-sharedcounts?format=json&performance_id=" + id,
                    function(data) {
                        callback(data);
                    });
            } else {
                core.ajax({
                    type: "POST",
                    url: config.domain + options.getApiUrl() + "/search-performance?output=json&apikey=123&client=iphone&performance_id=" + id + "&session_id=" + options.getApiSession(),
                    dataType: "json",
                    success: function(data) {
                        callback(data);
                    }
                });
            }
        },
        flagPerformance: function(id, reason, callback) {
            core.ajax({
                type: "POST",
                url: config.domain + "/ajax/flag.php?performance_id=" + id + "&reason=" + reason + "&embed=1",
                dataType: "text",
                success: function(data) {
                    callback(data);
                }
            });
        },
        bookmarkPerformance: function(id, callback, removeBookmark) {
            var ajaxUrl = config.domain + "/api/bookmark-performance?format=json&performance_id=" + id;
            if (removeBookmark === 1)
                ajaxUrl = config.domain + "/api/remove-performance-from-bookmarks?format=json&performance_id=" + id;
            core.ajax({
                type: "POST",
                url: ajaxUrl,
                dataType: "json",
                success: function(data) {
                    callback(data);
                }
            });
        },
        followChannel: function(id, callback, unfollow) {
            var ajaxUrl = config.domain + "/api/subscribe-to-channel?format=json&channel_id=" + id;
            if (unfollow === 1)
                ajaxUrl = config.domain + "/api/unsubscribe-from-channel?format=json&channel_id=" + id;
            core.ajax({
                type: "POST",
                url: ajaxUrl,
                dataType: "json",
                success: function(data) {
                    callback(data);
                }
            });
        },
        reCastVideo: function(userPostName, reCast, id, callback) {
            if (options.getApiUrl() === '' || !options.getApiUrl()) {
                core.ajax({
                    type: "POST",
                    url: config.domain + "/api/recast-performance?post_name=" + userPostName + "&recast=" + reCast,
                    dataType: "text",
                    success: function(data) {
                        callback(data);
                    }
                });
            } else {
                core.ajax({
                    type: "POST",
                    url: config.domain + options.getApiUrl() + "/recast-performance?output=json&apikey=123&client=iphone&performance-id=" + id + "&session_id=" + options.getApiSession() + "&recast=" + reCast,
                    dataType: "json",
                    success: function(data) {
                        callback(data);
                    }
                });
            }
        },
        getPerformanceComments: function(id, offset, limit, callback) {
            if (TouchCast.InteractiveLayer.getHLSInfo() !== '') {
                var livestreamId = TouchCast.InteractiveLayer.getHLSInfo().livestream_id;
                core.ajax({
                    type: "POST",
                    url: config.domain + options.getApiUrl() + "/livestream-comment-get?output=json&apikey=123&client=iphone&livestream_id=" + livestreamId + "&offset=" + offset + "&limit=" + limit,
                    dataType: "json",
                    success: function(data) {
                        callback(data);
                    }
                });
            } else {
                if (options.getApiUrl() === '' || !options.getApiUrl()) {
                    core.ajax({
                        type: "POST",
                        url: config.domain + "/api/get-performance-comments?format=json&performance_id=" + id + "&offset=" + offset + "&limit=" + limit,
                        dataType: "json",
                        success: function(data) {
                            callback(data);
                        }
                    });
                } else {
                    core.ajax({
                        type: "POST",
                        url: config.domain + options.getApiUrl() + "/get-performance-comments?output=json&apikey=123&client=iphone&performance-id=" + id + "&offset=" + offset + "&limit=" + limit,
                        dataType: "json",
                        success: function(data) {
                            callback(data);
                        }
                    });
                }
            }
        },
        postPerformanceComment: function(userPostName, commentText, id, callback) {
            if (options.getApiUrl() === '' || !options.getApiUrl()) {
                core.ajax({
                    type: "POST",
                    url: config.domain + "/api/post-performance-comment?format=json&post_name=" + userPostName + "&text=" + encodeURIComponent(commentText),
                    dataType: "json",
                    success: function(data) {
                        callback(data);
                    }
                });
            } else {
                core.ajax({
                    type: "POST",
                    url: config.domain + options.getApiUrl() + "/post-performance-comment?output=json&apikey=123&client=iphone&performance-id=" + id + "&session_id=" + options.getApiSession() + "&text=" + encodeURIComponent(commentText),
                    dataType: "json",
                    success: function(data) {
                        callback(data);
                    }
                });
            }
        }
    }
});
